module.exports = __webpack_public_path__ + "static/img/service-tech.1004d4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/service-tech.png
// module id = CrDg
// module chunks = 0